import * as React from 'react';
import { Fragment } from 'react';
import { observer } from 'mobx-react';
import { inject } from '../utils';
import { withTheme } from 'styled-components';
import { styled } from '../utils/styled';
import { propStyles } from '../utils/propStyles';
import Document from './Document';
import Disclaimers from './Disclaimers';
import { computed } from 'mobx';
import HTag from './HTag';
import { camelCase } from '@kurtosys/ksys-app-template/dist/utils/changeCase';
import { EntityStore, SuperscriptScope } from '../stores';

const LiteratureWrapper = styled<any, any>(
    'div',
    'literatureWrapper',
    'fundDocuments'
)`
    ${propStyles};
`;

LiteratureWrapper.defaultProps = {
    paddingX: ['md', 'xl'],
    paddingY: 'md',
    borderWidth: '1px',
    borderColor: 'gray300',
    borderStyle: ['none', 'solid none none none'],
};

const DocumentsList = styled<any, any>('ul', 'documentsList', 'fundDocuments')`
    ${propStyles};
`;

DocumentsList.defaultProps = {
    display: 'flex',
    flexDirection: ['column', 'row'],
    flexWrap: 'wrap',
};

const DocumentCategoryWrapper = styled<any, any>(
    'div',
    'documentCategoryWrapper',
    'fundDocuments'
)`
    ${propStyles};
`;
DocumentCategoryWrapper.defaultProps = {
    display: 'flex',
    flexDirection: ['column', 'row'],
};

const DocumentCategoryList = styled<any, any>(
    'ul',
    'documentCategoryList',
    'fundDocuments'
)`
    ${propStyles};
`;

DocumentCategoryList.defaultProps = {
    // display: 'flex',
    // flexWrap: 'wrap',
};

const DocumentCategory = styled<any, any>(
    'div',
    'documentCategory',
    'fundDocuments'
)`
    ${propStyles};
`;

DocumentCategory.defaultProps = {
    width: '100%',
};

interface FundDocumentProps {
    theme?: { [key: string]: React.CSSProperties };
    entityStore?: EntityStore;
    describedBy?: string;
}

@inject('entityStore')
@observer
class FundDocuments extends React.Component<FundDocumentProps, any> {
    @computed
    get hasDocumentCategories() {
        const { entityStore } = this.props;
        const { documentCategories } = entityStore;
        return documentCategories !== undefined;
    }

    @computed
    get groupedDocuments() {
        const { theme, entityStore, describedBy } = this.props;

        return (
            <Fragment>
                <HTag
                    componentTheme={'LiteratureHeading'}
                    defaultStyleProps={{
                        display: ['none', 'block'],
                        marginX: 'sm',
                        marginY: 'sm',
                        fontFamily: 'heading',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                    }}
                    level={2}
                    text={'Fund Literature'}
                />
                <DocumentsList {...theme.DocumentsList}>
                    {entityStore.groupedDocuments.map(
                        (documentGroup, index) => (
                            <Document
                                key={index}
                                index={index}
                                documentGroupName={
                                    documentGroup.documentGroupName
                                }
                                documents={documentGroup.documents}
                                showSingleDocument={
                                    documentGroup.showSingleDocument
                                }
                                metricContext={`fundDocuments-${camelCase(
                                    documentGroup.documentGroupName
                                )}`}
                                superscriptScope={SuperscriptScope.module}
                                describedBy={describedBy}
                            />
                        )
                    )}
                </DocumentsList>
            </Fragment>
        );
    }

    @computed
    get categoryDocuments() {
        const { theme, entityStore } = this.props;

        const { documentCategories } = entityStore;

        return (
            <DocumentCategoryWrapper {...theme.DocumentCategoryWrapper}>
                {documentCategories.map(documentCategory => {
                    return (
                        <DocumentCategory
                            key={documentCategory.heading}
                            {...theme.DocumentCategory}
                        >
                            <HTag
                                componentTheme={'DocumentCategoryHeading'}
                                defaultStyleProps={{
                                    display: 'block',
                                    marginX: 'sm',
                                    marginY: 'sm',
                                    fontFamily: 'heading',
                                    fontWeight: 'medium',
                                    fontSize: 'sm',
                                }}
                                level={2}
                                text={documentCategory.heading}
                            />
                            <DocumentCategoryList
                                {...theme.DocumentCategoryList}
                            >
                                {Object.keys(
                                    documentCategory.groupedDocuments
                                ).map((key, index) => {
                                    const groupedDocuments =
                                        documentCategory.groupedDocuments[key];
                                    return (
                                        <Document
                                            key={index}
                                            documentGroupName={
                                                groupedDocuments.documentGroupName
                                            }
                                            documents={
                                                groupedDocuments.documents
                                            }
                                            showSingleDocument={
                                                groupedDocuments.showSingleDocument
                                            }
                                            metricContext={`fundDocuments-${camelCase(
                                                documentCategory.heading
                                            )}-${camelCase(
                                                groupedDocuments.documentGroupName
                                            )}`}
                                        />
                                    );
                                })}
                            </DocumentCategoryList>
                        </DocumentCategory>
                    );
                })}
            </DocumentCategoryWrapper>
        );
    }

    render() {
        const { theme, entityStore } = this.props;

        return (
            <LiteratureWrapper {...theme.LiteratureWrapper}>
                {entityStore.groupedDocuments.length === 0 ? (
                    <Disclaimers
                        disclaimers={entityStore.noDocumentsDisclaimers}
                        theme={{
                            ...theme,
                            DisclaimersList: theme.NoDocumentsDisclaimersList,
                            DisclaimerListItem: {
                                justifyContent: 'center',
                                ...theme.NoDocumentsDisclaimerListItem,
                            },
                            DisclaimerContent: {
                                paddingX: 'md',
                                paddingY: 'md',
                                fontFamily: 'heading',
                                fontWeight: 'medium',
                                fontSize: 'sm',
                                ...theme.NoDocumentsDisclaimerContent,
                            },
                        }}
                    />
                ) : this.hasDocumentCategories ? (
                    this.categoryDocuments
                ) : (
                    this.groupedDocuments
                )}
                <Disclaimers
                    disclaimers={entityStore.fundCardDisclaimers}
                    theme={{
                        ...theme,
                        DisclaimersList: theme.DocumentsDisclaimersList,
                        DisclaimerListItem: theme.DocumentsDisclaimerListItem,
                        DisclaimerContent: theme.DocumentsDisclaimerContent,
                    }}
                />
            </LiteratureWrapper>
        );
    }
}

export default withTheme(FundDocuments) as any;



// WEBPACK FOOTER //
// ./src/Components/FundDocuments.tsx